import { render, staticRenderFns } from "./ywyNotReached.vue?vue&type=template&id=56d93e9c&scoped=true"
import script from "./ywyNotReached.vue?vue&type=script&lang=js"
export * from "./ywyNotReached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d93e9c",
  null
  
)

export default component.exports